
import { Button, Grid, LinearProgress } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useHistory, useLocation } from "react-router-dom";
import http from "../services/httpService";
import { investmentDetailsPath, prospectDetailsPath, searchFilter, handleSort } from "../utils/varialbles";
const useStyles = makeStyles({
    root: {
        width: '100%',
        backgroundColor: "#F5F7FA",
        padding: "7px"
    },
    circle: {

        borderRadius: "100%",
        background: "#3f51b5",
        color: "#fff",
    }
});
const getCurrency = (name) => {
    let currencyMapper = {
        "INR": "₹",
        "USD": "$",
        "CAD": "C$"
    }
    if (name && currencyMapper[name]) {
        return currencyMapper[name];

    } else {
        return currencyMapper["INR"];
    }
}
function GoalsDashboard() {
    const location = useLocation();
    let history = useHistory();
    const classes = useStyles();
    const [showWindow, setShowWindow] = useState(true);
    const [goalDetails, setGoalDetails] = useState([]);
    const myparam = location.state;
    useEffect(() => {
        if (myparam && (myparam.customer_id || myparam.cust__id)) {
            toast.loading("Please wait...");
            let cust_id = (myparam.customer_id || myparam.cust__id);
            http.get("/goals/" + cust_id).then(res => {
                toast.dismiss()
                if (res && res.data && res.data.data && Array.isArray(res.data.data) && res.data.data.length > 0) {
                    setGoalDetails(res.data.data)
                } else {
                    toast.error("Hola this user yet to set the goals!");
                    setShowWindow(false);
                }
            }).catch(err => {
                toast.error("Prospect Details not Found!");
            })
        } else {
            toast.error("Prospect Details not Found!");
            history.goBack();
            setShowWindow(false);
        }
    }, [])
    const gotoInvestorDetails = (e) => {
        e.preventDefault();
        if (myparam && myparam.cust__id) {
            history.push({
                "pathname": prospectDetailsPath, state: myparam
            });
        } else if (myparam && myparam.customer_id) {
            history.push({
                "pathname": investmentDetailsPath, state: myparam
            });
        }
    }
    return (
        <Grid container >

            <Paper className={classes.root}>
                <Grid container>
                    <Grid item xs={12} sm={6} md={1}>
                        <Button name="Overview" variant="contained" color="primary" onClick={gotoInvestorDetails}>Overview</Button>
                    </Grid>
                </Grid>
            </Paper>
            <Grid container style={{ marginTop: "10px" }}>
                <Grid item xs={false} sm={6} md={4} style={{ marginTop: 30 }}>
                    <Button variant="outlined" color="default" startIcon={<ArrowBackIosIcon />} onClick={gotoInvestorDetails}>Back</Button>
                </Grid>
                <Grid item xs={false} sm={6} md={6} style={{ marginTop: 30 }}>
                    <Typography color="textPrimary" variant="h5" >Goal Manager</Typography>
                </Grid>
            </Grid>
            <Grid container style={showWindow ? { display: "flex" } : { display: "none" }}>
                {
                    goalDetails.map((obj, inx) => {
                        return (
                            <Grid item xs={12} sm={4} md={4} key={inx + "goal"} style={{ marginTop: 60 }}>
                                <Typography color="textPrimary" variant="h5" >{"Goal " + (inx + 1)}</Typography>
                                <Grid container style={{ width: "76%", height: "400px", border: "1px solid #B5BCD8", borderRadius: "4px", marginTop: 10 }}>
                                    <Grid item xs={12} style={{ paddingLeft: 30, paddingTop: 10 }}>
                                        <Typography color="textPrimary" variant="body1" >Goal Name</Typography>
                                        <Typography color="textPrimary" variant="h6" >{obj.goalname}</Typography>

                                    </Grid>
                                    <Grid item xs={12} style={{ paddingLeft: 30 }}>
                                        <Typography color="textPrimary" variant="body1" >Target Amount</Typography>
                                        <Typography color="textPrimary" variant="h6" >{getCurrency(obj.currency) + " " + obj.goaltargetamt}</Typography>

                                    </Grid>
                                    <Grid item xs={12} style={{ paddingLeft: 30 }}>
                                        <Typography color="textPrimary" variant="body1" >Monthly Investment Amount</Typography>
                                        <Typography color="textPrimary" variant="h6" >{getCurrency(obj.currency) + " " + obj.mnthlyinvamt}</Typography>

                                    </Grid>
                                    <Grid item xs={12} style={{ paddingLeft: 30 }}>
                                        <Typography color="textPrimary" variant="body1" >Goal Duration</Typography>
                                        <Typography color="textPrimary" variant="h6" >{obj.duration}</Typography>

                                    </Grid>
                                    <Grid item xs={12} style={{ paddingLeft: 30 }}>
                                        <Typography color="textPrimary" variant="body1" style={{ color: "#159387", font: "normal normal medium 24px/32px Roboto" }}>{obj.percent}</Typography>
                                        <Typography color="textPrimary" variant="caption" style={{ display: "flex", columnGap: 50 }}><span>{"Started : " + obj.started}</span> <span >{"Ends : " + obj.ends}</span></Typography>
                                        <LinearProgress variant="determinate" value={obj.progress} color="primary" style={{ width: "80%" }} />
                                    </Grid>
                                </Grid>
                            </Grid>
                        )
                    })
                }
            </Grid>
        </Grid>
    )
}

export default GoalsDashboard;